import Axios from 'axios'
import store from '../store'
import strings from '@/strings'

const meal = {
  getClientId() {
    return store.getters['Client/clientId']
  },
  getMeals() {
    return Axios.get(`api/${strings.apiVersion.admin}/clients/${this.getClientId()}/meals`)
  },
  addMeal(meal) {
    return Axios.post(`api/${strings.apiVersion.admin}/clients/${this.getClientId()}/meals`, meal)
  },
  editMeal(meal) {
    return Axios.put(`api/${strings.apiVersion.admin}/clients/${this.getClientId()}/meals/${meal.id}`, meal)
  },
  activateMeal(mealId) {
    return Axios.patch(`api/${strings.apiVersion.admin}/clients/${this.getClientId()}/meals/${mealId}/activate`)
  },
  deactivateMeal(mealId) {
    return Axios.patch(`api/${strings.apiVersion.admin}/clients/${this.getClientId()}/meals/${mealId}/deactivate`)
  }
}

export default meal
